import { format } from "date-fns";
import { es } from "date-fns/locale/es";

export type NotifLogCsvRow = {
  sentAt: string;
  channel: string;
  type: string;
  clientName?: string | null;
  recipient: string;
  status: string;
  error: string | null;
};

function csvEscape(cell: string): string {
  if (/[",\n\r]/.test(cell)) return `"${cell.replace(/"/g, '""')}"`;
  return cell;
}

/** Genera el contenido CSV (UTF-8 con BOM para que Excel lo abra bien). */
export function buildNotifLogsCsvContent(rows: NotifLogCsvRow[]): string {
  const headers = ["Fecha", "Canal", "Tipo", "Cliente", "Destino", "Estado", "Detalle"];
  const lines = [headers.map(csvEscape).join(",")];
  for (const r of rows) {
    const fecha = format(new Date(r.sentAt), "yyyy-MM-dd HH:mm", { locale: es });
    lines.push(
      [
        csvEscape(fecha),
        csvEscape(r.channel),
        csvEscape(r.type),
        csvEscape(r.clientName ?? ""),
        csvEscape(r.recipient),
        csvEscape(r.status),
        csvEscape(r.error ?? ""),
      ].join(","),
    );
  }
  return "﻿" + lines.join("\n");
}

/** Descarga el CSV en el navegador (efecto lateral). */
export function downloadNotifLogsCsvFile(filename: string, content: string): void {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
